module.exports = __webpack_public_path__ + "static/media/29ADMSPC29.43788d16.jpg";